module.exports = __webpack_public_path__ + "static/img/proImg1.38e30ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg1.png
// module id = QC1B
// module chunks = 1